import { render } from "./TheBook.vue?vue&type=template&id=388c7b2b&lang=pug"
import script from "./TheBook.vue?vue&type=script&lang=js"
export * from "./TheBook.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__